import { createSlice } from "@reduxjs/toolkit";
import {
  CreateRepositorySuccessResponse,
  Repository,
} from "../types/repository";

export type RepositoriesState = {
  [repositoryId: string]: Repository;
};

const initialState: RepositoriesState = {};

const repositoriesSlice = createSlice({
  name: "repositories",
  initialState,
  reducers: {
    createRepository(
      state,
      action: { payload: { repository: CreateRepositorySuccessResponse } }
    ) {
      const { repository } = action.payload;
      state[repository.id] = repository;
    },
  },
});

export const repositoriesActions = repositoriesSlice.actions;

export default repositoriesSlice;
